// TODO: I REMOVED COLOR AND SIZE SELECTOR MAYBE DO SOMETHING BETTER FOR THEM?

import React, { Fragment, useCallback, useEffect, useState } from "react";
import "./index.css";
import { Tree, Divider, Spin, Typography } from "antd";
import { DownOutlined } from "@ant-design/icons";
import I18n from "../../../../i18n";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../application/store";
import { loadCategories } from "../../../../../application/categories-slice";
import { useHistory, useParams } from "react-router-dom";
import Colors from "./components/Colors";
import Sizes from "./components/Sizes";
import { Color, Size } from "../../../../../domain";

type FiltersProps = { selectedSizes: Size[]; selectedColors: Color[] };

const Filters: React.FC<FiltersProps> = ({ selectedSizes, selectedColors }) => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { loading, generalCategories } = useAppSelector(
    (state) => state.categories
  );
  const { id } = useParams<{ id: string }>();

  const [expandedKeys, setExpandedKeys] = useState([id]);

  const stableDispatch = useCallback(dispatch, []);
  useEffect(() => {
    if (loading !== "succeeded") stableDispatch(loadCategories());
    if (loading === "succeeded") setExpandedKeys([id]);
  }, [loading, stableDispatch, id]);

  return (
    <Fragment>
      <div className="filters-title">{I18n.general.categories}</div>
      <Spin spinning={loading !== "succeeded"}>
        <Tree
          selectedKeys={[]}
          expandedKeys={expandedKeys}
          onExpand={(expandedKeys, _) =>
            setExpandedKeys(expandedKeys.map((key) => key.toString()))
          }
          style={{}}
          onSelect={(_, info) =>
            history.push(
              `/category/${info.node.key}/${encodeURIComponent(
                info.node.title as string
              )}`
            )
          }
          treeData={generalCategories.map((generalCategory) => {
            return {
              key: generalCategory.id.toString(),
              title: generalCategory.title,
              children: generalCategory.subCategories.map((subCategory) => {
                return {
                  key: `${generalCategory.id}-${subCategory.id}`,
                  title: subCategory.title,
                  children: subCategory.categories.map((category) => {
                    return {
                      key: `${generalCategory.id}-${subCategory.id}-${category.id}`,
                      title: category.title,
                    };
                  }),
                };
              }),
            };
          })}
          switcherIcon={<DownOutlined />}
          autoExpandParent
          titleRender={(node) => (
            <Typography.Text
              style={node.key.toString() === id ? { fontWeight: 700 } : {}}
            >
              {node.title}
            </Typography.Text>
          )}
        />
      </Spin>
      {/*
      <Divider />
      <Sizes selectedSizes={selectedSizes} />
      <Divider />
      <Colors selectedColors={selectedColors} />
          */}
    </Fragment>
  );
};

export default Filters;
